import { useEffect, useState } from 'react';

import { Cancel } from '@mui/icons-material';
import { Collapse, Button, Alert } from '@mui/material';
import axios, { AxiosError } from 'axios';

import strings from 'constants/index';
import { formatError } from 'utils/request.utils';
interface ErrorProps {
  error: string | AxiosError;
}

const Error = ({ error }: ErrorProps) => {
  const [showError, setShowError] = useState<boolean>();

  const formattedError = axios.isAxiosError(error) && formatError(error);

  useEffect(() => {
    setShowError(error !== '');
  }, [error]);

  return (
    <Collapse in={showError}>
      <Alert
        sx={{ mt: 1 }}
        variant="filled"
        severity="error"
        icon={<Cancel fontSize="inherit" />}
        action={
          <Button color="inherit" onClick={() => setShowError(false)}>
            {strings.dismiss}
          </Button>
        }
      >
        {formattedError ||
          (typeof error === 'string' ? error : error.message || 'An error occurred')}
      </Alert>
    </Collapse>
  );
};

export default Error;
